<div *ngIf="messages?.length">
	<p-message *ngFor="let message of messages" [severity]="message.severity" [closable]="closable">
		<div>
			<h4>{{ message.summary }}</h4>
			<p>{{ message.detail }}</p>
			<ul *ngIf="message.data">
				<li *ngFor="let data of message.data">
					<span class="material-symbols-outlined"> warning </span>
					{{ data }}
				</li>
			</ul>
		</div>
	</p-message>
</div>
